// DIGIFRIEND product catalog data
export const WA_NUMBER = "62882003976301";

export const buildWA = (productName, price) => {
  const text = `Halo Admin DIGIFRIEND, saya tertarik untuk memesan:%0A%0A*${encodeURIComponent(
    productName
  )}*${price ? `%0AHarga: ${encodeURIComponent(price)}` : ""}%0A%0AMohon info lebih lanjut. Terima kasih!`;
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
};

export const capcutProducts = [
  {
    id: "capcut-private",
    name: "Capcut Premium Private",
    price: "Rp 23.000",
    badge: "Private",
    desc: "Akun pribadi penuh, semua fitur premium aktif tanpa gangguan.",
    cover: "/images/capcut-seeklogo.png",
  },
  {
    id: "capcut-sharing",
    name: "Capcut Premium Sharing",
    price: "Rp 8.000",
    badge: "Hemat",
    desc: "Akses semua fitur premium dengan harga paling hemat.",
    cover: "/images/capcut-seeklogo.png",
  },
];

export const gameProducts = [
  {
    id: "gta-5",
    name: "GTA 5 Legacy",
    price: "Rp 5.000",
    cover: "/images/gta5.jpg",
    tag: "Open World",
  },
  {
    id: "fh5",
    name: "Forza Horizon 5",
    price: "Rp 5.000",
    cover: "/images/fh5.jpg",
    tag: "Racing",
  },
  {
    id: "fh4",
    name: "Forza Horizon 4",
    price: "Rp 5.000",
    cover: "/images/fh4.jpg",
    tag: "Racing",
  },
  {
    id: "nfs-heat",
    name: "Need For Speed Heat",
    price: "Rp 5.000",
    cover: "/images/nfs-heat.jpg",
    tag: "Racing",
  },
  {
    id: "it-takes-two",
    name: "It Takes Two",
    price: "Rp 5.000",
    cover: "/images/it-takes-two.jpg",
    tag: "Co-op",
  },
  {
    id: "request-game",
    name: "Bebas Request Game",
    price: "Rp 5.000",
    cover: null, // gunakan logo gamepad
    tag: "Custom",
    request: true,
  },
];

export const ebookProducts = [
  {
    id: "atomic-habits",
    name: "Atomic Habits",
    price: "Rp 8.000",
    author: "James Clear",
    cover: "/images/atomic-habits.jpg",
    desc: "Bestseller dunia. Kebiasaan kecil, hasil luar biasa untuk pengembangan diri.",
  },
  {
    id: "request-ebook",
    name: "Bebas Request E-Book",
    price: "Mulai Rp 8.000",
    author: null,
    cover: null,
    request: true,
    desc: "Cari judul e-book lain? Request ke admin, kami carikan sesuai permintaan dengan harga bersahabat.",
  },
];

export const testimonials = [
  { name: "Rizky", age: 22, city: "Jakarta", text: "Pelayanan cepat, respon admin ramah banget. Pesan langsung dikirim dalam hitungan menit." },
  { name: "Nabila", age: 19, city: "Bandung", text: "Capcut premium aktif dan lancar dipakai. Worth it banget harganya." },
  { name: "Dimas", age: 27, city: "Surabaya", text: "Game repack aman, install sukses tanpa kendala. Ukuran ringan & gak ada virus." },
  { name: "Farhan", age: 24, city: "Yogyakarta", text: "Harga murah, trusted banget. Sudah jadi langganan tetap untuk kebutuhan digital." },
  { name: "Aisyah", age: 21, city: "Medan", text: "Admin fast response. E-book yang dipesan langsung dikirim ke email saya." },
  { name: "Bagas", age: 26, city: "Semarang", text: "Forza Horizon 5 jalan mulus di laptop saya. Recommended seller!" },
  { name: "Salsa", age: 18, city: "Depok", text: "Capcut premium sharing-nya stabil banget. Cocok buat content creator pemula." },
  { name: "Reza", age: 29, city: "Bekasi", text: "Sudah 3x order, semuanya beres tanpa drama. Trusted dan harga bersaing." },
];

export const features = [
  { title: "Pelayanan Cepat", desc: "Respon admin & pengiriman produk dalam hitungan menit, 24/7." },
  { title: "100% Aman", desc: "Game repack diuji, tanpa virus & malware. Akun premium garansi aktif." },
  { title: "Harga Terjangkau", desc: "Harga termurah di kelasnya tanpa mengorbankan kualitas." },
  { title: "Trusted Seller", desc: "Ratusan transaksi sukses dengan testimoni pelanggan asli." },
];
